import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { useFeatureToggles } from '@grandvisionhq/state';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import { pushVariantClickEvent } from '../../../DataLayer/Events/VariantSwitcherEvents.js';
import { ProductBlock } from '../components/ProductBlock.js';
import { useListingProductData } from '../hooks/use-listing-product-data.js';

const ExtendedProductBlock = ({ product , additionalUrlParams , onClick , onImpression , className , reimbursableLogos , tabIndex , productLocation ,  })=>{
    const [activeSku, setActiveSku] = React.useState(product.masterVariant.sku || '');
    const { wasSeen , ref  } = useWasSeenByUser();
    const { featureConfigs: { unitPriceFixedDecimalsConfig  } = {}  } = useFeatureToggles();
    const handleVariantChange = React.useCallback((sku)=>{
        const productType = product.productType;
        const selectedVariant = product.masterVariant.sku === sku ? product.masterVariant : product.variants.find((variant)=>variant.sku === sku
        );
        if (!selectedVariant) {
            console.error(`Cannot handle variant change if selectedVariant is not found`);
            return;
        }
        pushVariantClickEvent(selectedVariant, productType);
        sku && setActiveSku(sku);
    }, []);
    React.useEffect(()=>{
        if (wasSeen && onImpression) {
            onImpression();
        }
    }, [
        wasSeen
    ]);
    const { variantInfo , variantUrl , variantImages , otherVariants , promotionLabel , isInsuranceReimbursable ,  } = useListingProductData(product, activeSku, additionalUrlParams);
    const isReimbursableFiltered = (additionalUrlParams === null || additionalUrlParams === void 0 ? void 0 : additionalUrlParams.isInsuranceReimbursable) === 'true';
    if (!variantInfo || !variantUrl) {
        console.error('AlgoliaProductBlock: missing critical info required for rendering', {
            variantInfo,
            variantUrl
        });
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductBlock, swcHelpers.extends({
        ref: ref,
        productType: product.productType,
        className: className,
        url: variantUrl,
        images: variantImages,
        variants: otherVariants || [],
        promotionLabel: promotionLabel,
        activeSku: activeSku,
        onVariantChange: handleVariantChange,
        onClick: onClick,
        reimbursableLogos: reimbursableLogos,
        isInsuranceReimbursable: isInsuranceReimbursable,
        isReimbursableFiltered: isReimbursableFiltered,
        offering: product.offering,
        pricePerLiterFixedDecimals: unitPriceFixedDecimalsConfig === null || unitPriceFixedDecimalsConfig === void 0 ? void 0 : unitPriceFixedDecimalsConfig.plp,
        tabIndex: tabIndex,
        productLocation: productLocation
    }, variantInfo));
};

export { ExtendedProductBlock, ExtendedProductBlock as default };
//# sourceMappingURL=ExtendedProductBlock.js.map
